import {updateCantidadArticuloAttachPresupuesto} from "../../../../../catalogo/articulos/selector-cantidad";
window.updateCantidadArticuloAttachPresupuesto = updateCantidadArticuloAttachPresupuesto;
$(document).ready(function () {
    $('#modalAttachArticuloPresupuestoBotonAdjuntar').on('click', function () {
        attachArticuloAPresupuesto();
    });
});

window.mostrarModalAttachAPresupuesto = function (articuloId, articuloUnidades, obj) {
    $("#attachArticuloPresupuestoCampoIdArticulo").val(articuloId);
    let cantidad;

    if (articuloUnidades > 0) {
        cantidad = $(`#product-id-${articuloId}`).find('.select-editable-units input').val().split('-')[0];
    } else {
        cantidad = $(`#product-id-${articuloId}`).find('.product-quantity-input input').val();
    }

    $("#attachArticuloPresupuestoCampoCantidad").val(cantidad);
    getPresupuestos();
    toggleMoreActions('#btn-multiple' + articuloId);
}

window.getPresupuestos = async function (idPresupuesto = null) {
    $.ajax({
        url:        urlPresupuesto + '/get',
        type:       'POST',
        dataType:   'json',
        beforeSend: function beforeSend() {
            $("#modalAttachArticuloPresupuesto .loadingResults").show();
            $("#modalAttachArticuloPresupuesto .sinResultados").hide();
            $("#modalAttachArticuloPresupuestoBotonAdjuntar").attr('disabled', true);
            $("#attachArticuloPresupuestoFormulario")
                .hide()
                .find('select')
                .html(``)
                .attr('disabled', true);
        },
    })
     .done(function (response) {
         if (response.list.length) {
             let html = '';
             response.list.forEach(presupuesto => {
                 html += `<option value="${presupuesto.id}">${presupuesto.titulo}</option>`;
             });
             $("#attachArticuloPresupuestoFormulario")
                 .show()
                 .find('select')
                 .html(html)
                 .attr('disabled', false);
             $("#modalAttachArticuloPresupuesto .sinResultados").hide();
             $("#modalAttachArticuloPresupuestoBotonAdjuntar").attr('disabled', false);
             if (idPresupuesto) {
                 $('#attachArticuloPresupuestoFormulario select').val(idPresupuesto);
             }
         } else {
             $("#modalAttachArticuloPresupuesto .sinResultados").show();
         }
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status) {
             var errors = '';
             if (jqXHR.status === 422) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             pNotifyError(errors);
         }
     })
     .always(function () {
         $("#modalAttachArticuloPresupuesto .loadingResults").hide();
     });
}
let errors = '';
window.attachArticulosAPresupuestoDB = function (idPresupuesto, dataToSend) {
    $.ajax({
        url:        urlPresupuesto + '/' + idPresupuesto + '/sync/articulos',
        type:       'POST',
        data:       dataToSend,
        dataType:   'json',
        beforeSend: function beforeSend() {
            $('#modalAttachArticuloPresupuestoBotonAdjuntar').prop('disabled', true);
            $('#modalAttachArticuloPresupuestoBotonAdjuntar').html("<i class=\"ri-loader-4-line ri-formatted spinner\"></i>".concat(transAccionProcesando));
        }
    })
     .done(function (response) {
         pNotifySuccess(response.message);
         $('#modalAttachArticuloPresupuestoBotonCerrar').click();
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         } else {
             errors = error;
         }
         pNotifyError(errors);
     })
     .always(function () {
         $('#modalAttachArticuloPresupuestoBotonAdjuntar').prop('disabled', false);
         $('#modalAttachArticuloPresupuestoBotonAdjuntar').html("<i class=\"ri-send-plane-2-fill ri-formatted\"></i>".concat(transAccionAnadirAPresupuesto));
     });
}

window.attachArticuloAPresupuesto = function () {

    if (!$('#attachArticuloPresupuestoFormulario')[0].checkValidity()) {
        $("<input type=\"submit\">")
            .hide()
            .appendTo('#attachArticuloPresupuestoFormulario')
            .click()
            .remove();
    } else {
        cleanFeedback('attachArticuloPresupuesto', 'attachArticuloPresupuestoFormulario');
        const idPresupuesto = $('#attachArticuloPresupuestoCampoId').val();
        const id            = $('#attachArticuloPresupuestoCampoIdArticulo').val();
        const cantidad      = $('#attachArticuloPresupuestoCampoCantidad').val();

        const dataToSend = {
            sync_id:      {
                [id]: {cantidad},
            },
            detaching:    0,
            incrementing: 0
        }
        attachArticulosAPresupuestoDB(idPresupuesto, dataToSend);
    }
}
